(function () {
  var root = document.getElementById('notb-streams');
  if (!root) return;
  var L = root.getAttribute('data-lang') === 'en' ? 'en' : 'nl', loc = L === 'nl' ? 'nl-NL' : 'en-US';
  var hide = document.createElement('style'); hide.textContent = 'shopify-chat{display:none!important}'; document.head.appendChild(hide);
  // USD per stream, gross before splits. Sources listed on the page.
  var P = [
    { k: 'spotify', n: 'Spotify', lo: 0.003, hi: 0.005 },
    { k: 'apple', n: 'Apple Music', lo: 0.01, hi: 0.01 },
    { k: 'ytm', n: 'YouTube Music', lo: 0.008, hi: 0.008 },
    { k: 'amazon', n: 'Amazon Music', lo: 0.004, hi: 0.004 },
    { k: 'deezer', n: 'Deezer', lo: 0.0064, hi: 0.0064 },
    { k: 'tidal', n: 'TIDAL', lo: 0.013, hi: 0.013 }
  ];
  var T = {
    nl: { per: 'per stream', need: 'streams nodig', warn: 'Op Spotify verdient een nummer pas mee vanaf 1.000 streams per 12 maanden.' },
    en: { per: 'per stream', need: 'streams needed', warn: 'On Spotify a track only earns once it reaches 1,000 streams in 12 months.' }
  }[L];
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return root.querySelectorAll(s); };
  var mode = 'earn', share = 100;
  var inS = $('[data-st-streams]'), inM = $('[data-st-money]'), out = $('[data-st-out]'), warn = $('[data-st-warn]');
  function num(v) { return parseInt(String(v).replace(/[^0-9]/g, ''), 10) || 0; }
  function usd(v) {
    var d = v < 10 ? 2 : 0;
    return '$' + v.toLocaleString(loc, { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function int(v) { return Math.ceil(v).toLocaleString(loc); }
  function rate(r) { return '$' + r.toLocaleString(loc, { minimumFractionDigits: 3, maximumFractionDigits: 4 }); }
  function render() {
    var f = share / 100, html = '';
    if (mode === 'earn') {
      var s = num(inS.value);
      P.forEach(function (p, i) {
        var a = s * p.lo * f, b = s * p.hi * f;
        html += '<div class="st-card' + (i === 0 ? ' is-main' : '') + '"><span class="st-n">' + p.n + '</span><span class="st-v">' + (a === b ? usd(a) : usd(a) + ' tot ' + usd(b)) + '</span><span class="st-r">' + (p.lo === p.hi ? rate(p.lo) : rate(p.lo) + ' - ' + rate(p.hi)) + ' ' + T.per + '</span></div>';
      });
      warn.hidden = !(s > 0 && s < 1000);
    } else {
      var m = num(inM.value);
      P.forEach(function (p, i) {
        var a = f ? m / (p.hi * f) : 0, b = f ? m / (p.lo * f) : 0;
        html += '<div class="st-card' + (i === 0 ? ' is-main' : '') + '"><span class="st-n">' + p.n + '</span><span class="st-v">' + (Math.round(a) === Math.round(b) ? int(a) : int(a) + ' tot ' + int(b)) + '</span><span class="st-r">' + T.need + '</span></div>';
      });
      warn.hidden = true;
    }
    if (L === 'en') html = html.replace(/ tot /g, ' to ');
    out.innerHTML = html;
  }
  $$('[data-st-mode]').forEach(function (b) {
    b.addEventListener('click', function () {
      mode = b.getAttribute('data-st-mode');
      $$('[data-st-mode]').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      $('[data-st-earn]').hidden = mode !== 'earn'; $('[data-st-need]').hidden = mode !== 'need';
      render();
    });
  });
  $$('[data-st-q]').forEach(function (b) { b.addEventListener('click', function () { inS.value = Number(b.getAttribute('data-st-q')).toLocaleString(loc); render(); }); });
  $$('[data-st-share]').forEach(function (b) {
    b.addEventListener('click', function () {
      share = +b.getAttribute('data-st-share');
      $$('[data-st-share]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      render();
    });
  });
  [inS, inM].forEach(function (i) {
    i.addEventListener('input', render);
    i.addEventListener('blur', function () { var v = num(i.value); if (v) i.value = v.toLocaleString(loc); });
  });
  inS.value = (100000).toLocaleString(loc); inM.value = (1000).toLocaleString(loc);
  render();
})();
